import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { InputControlBase } from '../forms/input-control.base';

/**
 * @astral-compatible Preserve mask behavior when migrating callers.
 * Prefer `astral-masked-input` only when it supports the existing mask contract.
 */
@Component({
    selector: 'app-masked-text-box',
    templateUrl: './masked-text-box.component.html',
    styleUrls: ['./masked-text-box.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MaskedTextBoxComponent extends InputControlBase {
  constructor() {
    super();
  }

  @Input() mask: RegExp;
  @Input() maskFormat: any;

  private _caption: string;
  caption: string;
  ngOnInit() {
    super.ngOnInit();
    this.caption = this.control.caption;
    if (!this.mask) throw new Error('The mask was not specified.');
  }

  onblur() {
    super.onblur();
    if (this.maskFormat) {
      this.caption = this._caption;
    }
  }

  onfocus() {
    super.onfocus();
    if (this.maskFormat) {
      this._caption = this.caption;
      if (typeof this.maskFormat === 'string') this.caption = this.maskFormat;
      else {
        this.caption = this.control.caption;
      }
    }
  }

  onInput(value: string) {
    let newValue = this.mask.exec(value);
    this.control.setValue(newValue ? newValue[0] : null);
  }
}
